import { useEffect, useState } from 'react'

/** Sleduje, jestli má prohlížeč připojení k síti. */
export function useOnlineStatus(): boolean {
    const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine))

    useEffect(() => {
        const zapni = () => setOnline(true)
        const vypni = () => setOnline(false)

        window.addEventListener('online', zapni)
        window.addEventListener('offline', vypni)

        return () => {
            window.removeEventListener('online', zapni)
            window.removeEventListener('offline', vypni)
        }
    }, [])

    return online
}
